



































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
// import CardModalSkDiagosa from "@/components/modal/CardModalSkDiagosa.vue";
import CardInputSkDiagosa from "@/components/pemeriksaan/resumeSuketV2/CardInputSkDiagosa.vue";
import DataSKDP from "@/services/DataSKDP";
import { storeSoap } from "@/store/modules/soap";
import { storeSkDiagnosa } from "@/store/modules/skdiagnosa";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import moment from "moment";
import DataSkDiagnosa from "@/services/DataSkDiagnosa";
import http from "@/axios/http-common";
import { listTindakLanjut } from "@/utility/DataReferensi";
import { confirmRemove } from "@/utility/CommonHelper";
import InterfaceSkDiagnosa from "@/apiInterface/InterfaceSkDiagnosa";

@Component({
  components: {
    CardModalTtd,
    // CardModalSkDiagosa,
    CardInputSkDiagosa
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardDiagnosa extends Vue {
  @Prop() readonly register!: string;
  @Prop() expandInput!: boolean;
  isReadOnly!: () => boolean;

  get readOnlyMode(): boolean {
    return this.isReadOnly();
  }
  sess_login = this.stateuser;
  pageTab = "tab-soap";
  modalTtdDiagnosis = false;
  modalSkDiagnosa = false;
  idDiagnosa = "";
  dataSuketDiagnosa = {};
  selectedDiagnosa = {};

  mounted() {
    storeSkDiagnosa.actSKD_on_reg(this.register);
    // this.getSKDP();
  }

  get listTindakLanjut() {
    return listTindakLanjut;
  }

  get suketContent() {
    return storeSkDiagnosa.skDiagnosa;
  }


  get statesoapdetail() {
    return storeSoap.detailSoap;
  }

  get stateuser() {
    return userModule.user;
  }

  get canCreate() {
    if (this.readOnlyMode) return false;
    return this.stateuser.profesi === "Dokter";
  }

  get canAdd() {
    if (this.readOnlyMode) return false;
    if (userModule.user.unit_id == "01" || userModule.user.unit_id > "35") {
      return this.canCreate;
    } else {
      return this.canCreate && this.statesoapdetail.length;
    }
  }

  backPageSoap() {
    this.$emit("pageTab", this.pageTab);
  }

  passTtd(val) {
    // console.log("ttd", val, "id", this.statedetaildiagnosa.id);

    appModule.setLoading(true);

    const dt = DataSkDiagnosa.saveDataTtdSkDiagnosa(
      this.selectedDiagnosa["id"],
      this.selectedDiagnosa["dpjp_id"],
      val
    );
    dt.then(dt => {
      appModule.setLoading(false);
      // console.log(dt);
      if (dt["status"] != 1) {
        // appModule.sendErrorAlert(dt["err"]);
        appModule.addMsgTtd(dt["data"]["message"]);
        this.modalTtdDiagnosis = true;
      } else {
        this.modalTtdDiagnosis = false;
        appModule.NoticeDelay(
          "Berhasil Tanda Tangan Surat Keterangan Diagnosa"
        );
        appModule.addMsgTtd("");
        storeSkDiagnosa.actSKD_on_reg(this.register);
      }
    });
  }

  ttd(dt) {
    this.selectedDiagnosa = dt;
    this.modalTtdDiagnosis = true;
  }

  tambah() {
    // this.dataSkDiagnosa = {};
    // storeSkDiagnosa.actSKD_on_new();
    this.dataSuketDiagnosa = {};
    // this.modalSkDiagnosa = true;
    this.expandInput = true;
  }

  edit(dt) {
    this.dataSuketDiagnosa = dt;
    this.expandInput = true;
  }

  cetak(id) {
    // -----------------Ini yang asli jika sudah di Build--------------------
    // const routeData = this.$router.resolve({
    //   name: "cetakSkDiagnosa",
    //   params: { id: id },
    // });
    // window.open(routeData.href, "_blank");
    // -----------------^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^--------------------
    const routeData = http.getAPI() + "/suket-diagnosa/" + id + "/pdf";
    window.open(routeData, "_blank");
  }

  remove(id) {
    const q = confirmRemove(
      "Surat Keterangan Diagnosa",
      "Hapus Surat Keterangan Diagnosa ini?"
    );

    if (q) {
      InterfaceSkDiagnosa.deleteSkDiagnosaByID(id).then(resp => {
        console.log(resp);
        if (resp.data.status == 1) {
          storeSkDiagnosa.actSKD_on_reg(this.register);

          appModule.sendSuccessNotice("SuketDiagnosa berhasil dihapus");
        }
      });
    }
  }


  getHumanDate(date) {
    return date ? moment(date).format("DD MMMM YYYY") : "";
  }

  getHumanDateTime(date) {
    return date ? moment(date).format("DD MMMM YYYY HH:mm:ss") : "";
  }
  closeExpand(v) {
    this.expandInput = v;
  }

  parseTindakLanjut(val) {
    const tl =
      this.listTindakLanjut.find(item => item.id == val.tindak_lanjut.id) ??
      null;

    let text = tl ? tl.nama : "";

    if (val.tindak_lanjut.id == 1) {
      text += " (" + val.klinik_tujuan.nama + ")";
    }

    return text;
  }
}
